import request from '@/utils/request'

const getVinApi = {

}

// 车辆信息
getVinApi.getVehicle = vin => {
  return request({
    url: '/mes/getSalesInfoByVin/' + vin,
    method: 'get'
  })
}

// 车辆信息 海外-分表
getVinApi.getVehicleOversea = vin => {
  return request({
    url: '/mes/getOverseasSalesInfoByVin/' + vin,
    method: 'get'
  })
}

// 整车物料编码
getVinApi.getVehicleList = data => {
  return request({
    url: '/mdVehicleMaterial/getVehicleList',
    method: 'post',
    data
  })
}

// 整车物料编码--海外
getVinApi.getOverseasVehicleList = data => {
  return request({
    url: '/overseasVehicleMaterial/getVehicleList',
    method: 'post',
    data
  })
}

// 获取历史vin号
getVinApi.getHistoryVinList = () => {
  return request({
    url: '/mes/getHistoryVinList',
    method: 'get'
  })
}

// 获取8位查询的vin号
getVinApi.getVinList = vin => {
  return request({
    url: '/mes/getVinList/' + vin,
    method: 'get'
  })
}


getVinApi.getSingleVehC3dObject = data => {
  return request({
    url: '/c3d/getSingleVehC3dObject',
    method: 'post',
    data
  })
}

getVinApi.getVehConfigList = data => {
  return request({
    url: '/config/getList',
    method: 'post',
    data
  })
}

getVinApi.getConfigPageList = data => {
  return request({
    url: '/config/getPageList',
    method: 'post',
    data
  })
}

getVinApi.getExcelLog = state => {
  return request({
    url: '/excel/log/getLog/' + state,
    method: 'get'
  })
}

getVinApi.deleteLog = data => {
  return request({
    url: '/config/delete',
    method: 'post',
    data
  })
}

getVinApi.getConfigDropdown = data => {
  return request({
    url: '/mdVehicleMaterial/getConfigDropdown',
    method: 'post',
    data
  })
}

getVinApi.getConfigList = data => {
  return request({
    url: '/config/getImportPageList',
    method: 'post',
    data
  })
}

getVinApi.getEsMatlCode = data => {
  return request({
    url: '/es/getMaterialConfigList',
    method: 'post',
    data
  })
}

getVinApi.getEsQueryList = data => {
  return request({
    url: '/es/query',
    method: 'post',
    data
  })
}

getVinApi.getC3Durl  = data => {
  return request({
    url: '/es/getUrl',
    method: 'post',
    data
  })
}

// 车型对照表相关API
getVinApi.getDevelopSellModelPage = data => {
  return request({
    url: '/developSellModel/getDevelopSellModelPage',
    method: 'post',
    data
  })
}

getVinApi.deleteDevelopSellModel = id => {
  return request({
    url: '/developSellModel/deleteDevelopSellModel',
    method: 'post',
    data: [id] // 传入数组形式的ids
  })
}

export default getVinApi
